import * as axios from 'axios';
import * as uuid from 'uuid';
import {Caller} from "@/lib/Caller";

const baseURL = process.env.VUE_APP_API_URL

const instance = axios.create({
  baseURL,
  timeout: 5000
});
instance.interceptors.request.use(async req => {
  const token = getToken()
  if (token) req.headers['Authorization'] = `Bearer ${token}`
  return req
})


//API Manager
/**
 *
 * @param {Object} Events
 * @param {Object} Namespace
 * @param EventsMapping
 * @return {{Events:Object, Register(string, function): string, Unregister(number[]): void}}
 * @constructor
 */
function FeatureEventManager(Events, Namespace, EventsMapping) {
  const _registre = {};
  const NS        = {
    ...Events,
    ...Namespace,
    Register(eventName, callBack) {
      return _registerCB(_registre, eventName, callBack)
    },
    Unregister(id) {
      return _unregisterCB(_registre, id)
    }
  }
  EventsMapping.forEach((ev, fn) => {
    const oldFunction = NS[fn]
    if (typeof oldFunction === "function") {
      NS[fn] = async(...args) => {
        const res = await oldFunction(...args);
        _triggerEvent(_registre, Events[ev]);
        return res
      }
    }
  })
  return {
    Events,
    ...NS,
    Register(eventName, callBack) {
      return _registerCB(_registre, eventName, callBack)
    },
    Unregister(id) {
      return _unregisterCB(_registre, id)
    }
  };
}

// Do Namespace
const key        = "textes",
      Textes     = {
        async GetList(filter, local = false) {
          let list = []
          if (!local) list.push(...await instance.get('/texts/list', {data: {filter}}).then(res => res.data))
          list = GetList(key, filter).reduce((p, t) => {
            const index = p.findIndex(({id}) => t.id === id);
            if (index === -1) {
              p.push(t)
            } else {
              p[index] = {...p[index], ...t}
            }
            return p
          }, list);
          return list;
        },
        Get(id) {
          if (LocalID.isLocalID(id)) return new Promise(resolve => resolve(Get(key, id)))
          return instance.get(`/texts/${id}`).then(res => res.data)
        },
        Correct(item) {
          const form = new FormData()
          Object.keys(item).forEach(key => {
            form.append(key, item[key])
          })
          return instance.post(`/texts/correction`, form, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }).then(res => res.data)
        },
        createLocal(titleOrItem) {
          if (typeof titleOrItem === 'string') {
            return Create(key, {title: titleOrItem, texte_original: "", type: 1});
          }
          return Create(key, {texte_original: "", type: 1, ...titleOrItem})
        },
        SaveLocal(item) {
          if (!item.id) return Create(key, item).id
          return Save(key, item.id, item)
        },
        Save(item) {
          const form = new FormData()
          Object.keys(item).forEach(key => {
            form.append(key, item[key])
          })
          return instance.post(`/texts/save`, form, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }).then(res => res.data);
        },
        ChangeStatus(item) {
          return instance.post(`/texts/changeStatus`, item,).then(res => res.data);
        },
        discardLocal(id) {
          Remove(key, id)
        },
        Submit(item) {
          return instance.post(`/texts`, item).then(res => res.data);
        },
        Create(item) {
          return instance.post(`/texts/create`, item).then(res => res.data);
        },
  
      },
      /**
       * @name Discussion
       * @type {{
       * Events: {UPDATE_STATUS: "update"},
       * MessageStatus:{Unseen:string, Seen:string, Sent:string},
       * GetMessages(discussion_id:string, options?:object): Promise,
       * GetDiscussions(): Promise,
       * SendMessage(discussion_id, message, type): Promise,
       * Open(user_id): Promise,
       * UpdateStatus(ids): Promise}&{
       * Register(string, Function): string,
       * Unregister(string[])
       * }}
       */
      Discussion = FeatureEventManager(
        {UPDATE_STATUS: "update"},
        {
          MessageStatus: {Unseen: "unseen"},
          GetMessages(discussion_id, options) {
            if (!discussion_id) return [];
            return instance.get(
              `/discussion/${discussion_id}`,
              {
                params: {
                  ...options
                }
              })
              .then(res => res.data)
          },
          GetDiscussions() {
            return instance.get(
              `/discussion`).then(res => res.data)
          },
          SendMessage(discussion_id, message, type) {
            let sender;
            switch (type) {
              case 1:
                sender = sendAudio
                break;
              default:
                sender = sendText
            }
            return sender(discussion_id, message).then(res => res.data)
          },
          Open(user_id) {
            return instance.post(
              `/discussion/open`, {
                user_id,
              }).then(res => res.data)
          },
          UpdateStatus(ids) {
            return instance.post("discussion/update", {ids}).then(res => res.data)
          },
        },
        new Map([["UpdateStatus", "UPDATE_STATUS"]])
      ),
      /**
       * @name Exercice
       * @type {{
       * Events: {GET: "get"},
       * FormatContenu(contenu:string): string,
       * List(filter?:object,student?:number): Promise,
       * Get(id:string): Promise,
       * Save(data:object): Promise,
       * Register(event:string, cb:function): string,
       * Unregister(ids:string[]): void}}
       */
      Exercice   = FeatureEventManager(
        {GET: "get"},
        {
          FormatContenu(contenu) {
            return contenu.replaceAll(/<br( |)\/>/g, '')
          },
          List(filter, student) {
            return instance.post(`/exercice/list`, {filter, student}).then(res => res.data || []);
          },
          Get(id) {
            return instance.get(`/exercice/${id}`).then(res => res.data?.id ? res.data : {});
          },
          Save(data) {
            return instance.post('/exercice', data).then(res => res.data);
          }
        },
        new Map([["Get", "GET"]])
      );

//private
function sendText(discussion_id, message) {
  return instance.post(
    `/discussion`, {
      discussion_id, message, type: 0,
    })
}

function sendAudio(discussion_id, blob) {
  const form = new FormData();
  form.append("discussion_id", discussion_id);
  form.append("type", "audio");
  form.append("message", blob);
  return instance.post('/discussion', form, {
    headers: {
      //'Content-Length': file.length,
      'Content-Type': 'multipart/form-data'
    },
  })
}

const authKey       = "auth", roleKey = "role";
const _authRegistre = {}

function _authTrigger(eventName) {
  return _triggerEvent(_authRegistre, eventName)
}

function _registerCB(registre, eventName, cb) {
  const id            = uuid.v4();
  registre[eventName] = {...registre[eventName], [id]: cb};
  return eventName + "." + id;
}

function _triggerEvent(registre, eventName) {
  const EventCallBacks = registre[eventName] || {};
  Object.keys(EventCallBacks).forEach(id => EventCallBacks[id]?.());
}

function _unregisterCB(registre, id) {
  const [eventName, key] = id.split(".");
  delete registre[eventName][key];
}

const Auth = {
  Events: {Login: "login", Role: "role", Logout: "logout"},
  async refreshRole() {
    return instance.get('/auth/role').then(({data}) => {
      Save(authKey, roleKey, data);
      _authTrigger(Auth.Events.Role);
      return data
    }, error => error);
  },
  LogIn(data) {
    return axios({
      method: "POST",
      url   : baseURL + '/user/login',
      data
    })
      .then(res => {
        setToken(res.data);
        Auth.refreshRole();
      })
      .then(() => {
        _authTrigger(Auth.Events.Login);
      })
      .catch(error => (error.response.data))
  },
  LogAs(clef_mail) {
    return instance
      .post('/user/logAs', {clef_mail})
      .then(res => {
        setToken(res.data);
        Auth.refreshRole();
        _authTrigger(Auth.Events.Login);
        return res.data
      })
  },
  SignIn(data) {
    return axios({
      method: "POST",
      url   : baseURL + '/user/register',
      data
    })
      .then(res => {
        setToken(res.data);
      })
      .then(() => {
        _authTrigger(Auth.Events.Login);
      })
      .catch(error => (error.response.data))
  },
  RequestPassword(mail) {
    return axios({
      method: "POST",
      url   : baseURL + '/user/requestPassword',
      data  : {mail}
    });
  },
  ResetPassword(token, password) {
    console.log("send ResetPassword");
    return axios({
      method : "POST",
      url    : baseURL + '/user/resetPassword',
      data   : {password},
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  LogOut() {
    setToken("");
    Remove(authKey, roleKey);
    _authTrigger(Auth.Events.Logout);
  },
  Role() {
    return Get(authKey, roleKey)
  },
  Token() {
    return getParseToken();
  },
  IsLogged() {
    const token = getParseToken();
    return token?.exp > Date.now() / 1000;
  },
  IsTeacher() {
    return this.Role() === "PROFESSEUR" || this.IsAdmin()
  },
  IsAdmin() {
    return this.Role() === "ADMIN"
  },
  Register(eventName, callBack) {
    return _registerCB(_authRegistre, eventName, callBack)
  },
  Unregister(id) {
    return _unregisterCB(_authRegistre, id)
  }
}

const Correction = {
  Type: {
    Save({id, error, correction, comment}) {
      return instance
        .post("/correction/type/save", {id, error, correction, comment}).then(res => res.data)
    },
    Get(error) {
      return instance.get("/correction/type", {params: {error}}).then(res => res.data)
    },
  },
}

const User = {
  ActiveUser() {
    return instance.get(`/user`).then(res => res.data);
  },
  GetUsers(filter) {
    return instance.post(`/user/list`, {filter}).then(res => res.data);
  },
  GetUser(id) {
    return instance.get(`/user/${id}`).then(res => res.data);
  },
  UpdateUser(user) {
    console.log(user)
    return instance.post(`/user/update`, user).then(res => res.data);
  }
}

// LocalStorage
function getObject(key) {
  const data = localStorage.getItem(key)
  return JSON.parse(data) || {}
}

function Create(key, data) {
  const object = getObject(key)
  const id     = LocalID.generateID();
  object[id]   = {id, ...data, created_at: LocalID.getTime(id)}
  localStorage.setItem(key, JSON.stringify(object))
  return object[id]
}

function Get(key, id) {
  const object = getObject(key)
  return id ? object[id] : object
}

// Save (key, id, data) or (key, data)
function Save(key, ...args) {
  switch (args.length) {
    case 1:
      return _save2(key, ...args)
    case 2:
      return _save3(key, ...args)
    default:
      console.Warning("Unsupported number of args:", args.length);
  }
}

function _save3(key, id, data) {
  const object = getObject(key)
  object[id]   = data
  localStorage.setItem(key, JSON.stringify(object))
  return id;
}

function _save2(key, item) {
  if (item.id) {
    const object    = getObject(key)
    object[item.id] = item
    localStorage.setItem(key, JSON.stringify(object))
    return item.id
  }
  localStorage.setItem(key, JSON.stringify(item))
  return key;
}

function Remove(key, itemKey) {
  const object = getObject(key)
  delete object[itemKey]
  localStorage.setItem(key, JSON.stringify(object))
}

function GetList(key, filter) {
  const object = getObject(key)
  return Object.keys(object).map(k => object[k]).filter(toFilter(filter));
}

function toFilter(filter) {
  return (v) => !filter?.Equal || filter.Equal.every(
    (({field, value}) => v[field] === value)
  );
}

const Storage = {
  Create, Get, Save, Remove, GetList
}

//ID function
const localKey = "localKey"
const LocalID  = {
  generateID() {
    return localKey + "-" + Date.now()
  },
  isLocalID(id) {
    return !!id && !!id.slice && id.slice(0, 8) === localKey
  },
  getTime(id) {
    return !this.isLocalID(id) ? 0 : parseInt(id.slice(9))
  }
}


// Token
function getClefMail() {
  return window.__TOKEN__;
}

function getMetaToken() {
  return window.__METATOKEN__;
}

function setToken(token) {
  Storage.Save('auth', 'token', token)
}

function getToken() {
  return Storage.Get("auth", 'token');
}

function getParseToken() {
  return parseJwt(getToken());
}

function parseJwt(token) {
  if (!token) return {};
  var base64Url = token.split('.')[1];
  var base64    = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

//Produit
/**
 *
 * @type {
 * Caller, {
 * Tags():Promise,
 * Count(filter?:Object):Promise,
 * List(filter?:Object):Promise,
 * GetContenuPrincipal(id:string):Promise,
 * ContenuPrincipal():Promise,
 * ContenuPrincipalList():Promise,
 * Get(id:number|string):Promise,
 * Activate(clef:string):Promise,
 * SaveCP(data:Object):Promise,
 * Save(data:Object):Promise,
 * }}
 */
const Produit = new Caller(
  {
    Tags() {
      return instance.post('/produit/tags', {}).then(res => res.data);
    },
    Count(filter) {
      return instance.post('/produit/count', {filter}).then(res => res.data);
    },
    List(filter) {
      return instance.post('/produit/list', {filter}).then(res => res.data);
    },
    GetContenuPrincipal(id) {
      return instance.get(`/produit/principaux/${id}`).then(res => res.data);
    },
    ContenuPrincipal() {
      return instance.get('/produit/principaux').then(res => res.data);
    },
    ContenuPrincipalList() {
      return instance.get('/produit/principaux/list').then(res => res.data);
    },
    Get(id) {
      return instance.get(`/produit/${id}`).then(res => res.data);
    },
    Activate(clef) {
      return instance.post(`/produit/activate/`, {clef}).then(res => res.data);
    },
    SaveCP(data) {
      return instance.post(`/produit/principaux/save`, data).then(res => res.data);
    },
    Save(data) {
      return instance.post(`/produit/save`, data).then(res => res.data);
    }
  });

//Lecons
/**
 *
 * @type {
 * Caller, {
 * List(filter:object):Promise,
 * Get(id:string|number):Promise
 * }}
 */
const Lecons = new Caller(
  {
    List(filter) {
      return instance.post('/lecons/list', {filter}).then(res => res.data);
    },
    Get(id) {
      return instance.get(`/lecons/${id}`).then(res => res.data);
    }
  })

//Audio
/**
 *
 * @type {
 * Caller, {
 * Generate(text:string, options:any):Promise,
 * GetHash(text:string, options:any):Promise
 * }}
 */
const Audio = new Caller(
  {
    Generate(text, options) {
      return instance.post(`/audio/generate`, {text, options}).then(res => res.data);
    },
    GetHash(text, options) {
      return instance.post(`/audio/getHash`, {text, options}).then(res => res.data);
    }
  }
)

export {
  Textes,
  Auth,
  Audio,
  User,
  Discussion,
  Correction,
  Exercice,
  Produit,
  Lecons,
  LocalID,
  Storage
}